import { AbstractControl } from '@angular/forms';

export function getDateValue(control: AbstractControl): number {
  let val = '';
  const key = 'value';
  if (Object.prototype.hasOwnProperty.call(control.value, key)) {
    val = control.value.value;
  } else {
    val = control.value;
  }
  return Number(val);
}
